"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const react_1 = __importStar(require("react"));
const ControlSeparator_1 = require("../../../controls/ControlSeparator");
const helpers_1 = require("../../../helpers");
const StackView_1 = require("../../../StackView");
const Text_1 = require("../../../Text");
const Separator_styles_1 = require("./Separator.styles");
const createToolbarUIElement_1 = require("../../helpers/createToolbarUIElement");
const types_1 = require("../../types");
exports.Separator = (0, createToolbarUIElement_1.createToolbarUIElement)('Separator', types_1.TOOLBAR_ITEM_TYPE.separator, (_a, ref) => {
    var { className, text, style } = _a, rest = __rest(_a, ["className", "text", "style"]);
    const dataSelectorId = (0, react_1.useMemo)(() => rest['data-selector-id'] || 'toolbar-separator', [rest]);
    const textRender = (0, react_1.useMemo)(() => Boolean(text) && react_1.default.createElement(Text_1.Text, { view: Text_1.TEXT_VIEW.primary }, text), [text]);
    return (react_1.default.createElement(Separator_styles_1.StyledSeparator, Object.assign({}, rest, { ref: ref, style: style, testId: dataSelectorId, gap: StackView_1.STACK_GAP.m, align: StackView_1.STACK_ALIGN.center, "data-separator": true, className: (0, helpers_1.cn)('vm-Separator', className) }),
        react_1.default.createElement(ControlSeparator_1.ControlSeparator, null),
        textRender));
});
//# sourceMappingURL=Separator.js.map